import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";

import logger from "./middleware/logger";
import toastMiddleware from "./middleware/toast";
import reducer from "./reducer";

const store = configureStore({
  reducer: reducer,
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
    logger(),
    toastMiddleware,
  ],
});

if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept("./reducer", () => {
    const newRootReducer = require("./reducer").default;
    store.replaceReducer(newRootReducer);
  });
}

export default store;
